"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _getConsumingUXCoreVersion = _interopRequireDefault(require("./getConsumingUXCoreVersion"));
var _satisfies = _interopRequireDefault(require("semver/functions/satisfies"));
var _parsePackageVersion = _interopRequireDefault(require("./parsePackageVersion"));
function compareUXCoreVersions(appUXCVersion, sourceApp, logError, namespace) {
  var consumingVersion = (0, _getConsumingUXCoreVersion.default)();
  var packageVersion = (0, _parsePackageVersion.default)(appUXCVersion);
  if (consumingVersion && packageVersion) {
    if (!(0, _satisfies.default)(consumingVersion, packageVersion)) {
      logError(new Error("Incompatible UXCore versions between ".concat(sourceApp, " - ").concat(consumingVersion, " \n      and ").concat(namespace, " - ").concat(packageVersion)));
    }
  }
}
var _default = exports.default = compareUXCoreVersions;